handleVatUpdatesForUpsellButton = ->
  applyVatToCheckoutButton()

applyVatToCheckoutButton = ->
  if vatTaxableCountry() && confirmButtonPresent()
    productIds = $(".btn-instant-checkout").map((index, btn) -> btn.value)
    $.ajax({ url: vatUpsellCheckerPath() + "?" + $.param({ product_id: productIds.toArray() }), method: "GET", headers: { "X-CSRF-Token": $( 'meta[name="csrf-token"]' ).attr( 'content' ) } })
      .then(includeVatInPrices)

includeVatInPrices = (data) ->
  for vatProduct in data.vat_adjusted_products
    $(".price#instant-checkout-upsell-price-product-" + vatProduct.product_id).each((index, btn) ->
      btn.textContent = vatProduct.formatted_final_price
      btn.removeAttribute("hidden")
    )

vatUpsellCheckerPath = ->
  "/vat_rate_for_upsell_products"

vatTaxableCountry = ->
  $("meta[id=fedora-data]").attr("data-vat-country")

confirmButtonPresent = ->
  $(".btn-instant-checkout").length > 0

$(document).ready(handleVatUpdatesForUpsellButton)
